<template>
  <!-- Table Container Card -->
  <b-card :title="$t('operation.roles')"">
    <!-- Add modal -->
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-create"
      centered
      modal-class="modal-primary"
      ok-only
      :ok-title="$t('common.add')"
      @ok="addRole"
    >
      <b-form-group :label="Role">
        <b-form-input v-model="addForm.name" placeholder="Enter Role" />
      </b-form-group>
    </b-modal>
    <!-- Edit modal -->
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      :title="`${$t('common.edit')} ${$t('operation.role')}`"
      :ok-title="`${$t('common.ok')} `"
      @ok="editRole()"
    >
      <b-form-group :label="$t('operation.role')">
        <b-form-input v-model="editForm.name" :placeholder="$t('operation.role')" />
      </b-form-group>
    </b-modal>
    <div class="m-2">
      <b-row>
       
       
        <b-col cols="12" md="11">
          <b-form-group class="" :label="`${$t('common.search')} ${$t('operation.roles')}`" label-for="Role">
            <b-form-input
              @keyup.enter="index()"
              v-model="filterData.name"
              :placeholder="$t('operation.role')"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="1"
          class="d-flex align-items-center justify-content-start mt-75 mb-1 mb-md-0"
        >
          <b-button variant="primary" @click="index()">               {{ $t('common.search') }}
 </b-button>
        </b-col>
      </b-row>
    </div>
    <b-row>
        <b-col
          cols="12"
          md="12"
          class="d-flex align-items-center justify-content-between  my-2 "
        >
          <h3>{{ $t('common.table') }} {{ $t('operation.roles') }}</h3>
          <b-button   
            variant="primary"
            @click="
              $router.push({
                name: 'create-role',
              })
            "
          >
            {{ $t('common.add') }} {{ $t('operation.role') }}
          </b-button>
        </b-col>
      </b-row>
    <b-table
      :items="dataTable"
      responsive
      :fields="tableColumns"
      primary-key="id"
      v-if="!loading"
      show-empty
      empty-text="No matching records found"
      class="position-relative"
    >

      <!-- Column: Id -->
      <template #cell(Id)="data">
        <b-link class="font-weight-bold">
          {{ data.item.id }}
        </b-link>
      </template>

      <!-- Column: Name -->
      <template #cell(Name)="data">
        <b-media vertical-align="center">
          <span class="font-weight-bold d-block text-nowrap">
            {{ data.item.name }}
          </span>
        </b-media>
      </template>

      <!-- Column: created_at -->
      <template #cell(Created_at)="data">
        <span class="text-nowrap" style="unicode-bidi: isolate" :style="{  direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr' }">
          {{ data.item.created_at }}
        </span>
      </template>

      <!-- Column: updated_at -->
      <template #cell(Updated_at)="data">
        <span class="text-nowrap" style="unicode-bidi: isolate" :style="{  direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr' }">
          {{ data.item.updated_at }}
        </span>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div class="text-nowrap d-flex">
          <b-button v-if="$store.state.app.permissions.includes('assign-permission-to-role')"
            variant="outline-primary"
            pill
            size="sm"
            class="mx-1"
            @click="
              $router.push({
                name: 'operations-roles-preview',
                params: { id: data.item.id },
              })
            "
          >
            {{$t('common.preview')}}
          </b-button>
           <ActionsButtons
          :noDelete="true"
                editPerm="update-role"
                @editToggle="showEditModel(data.item)"
              />
         
        </div>
      </template>
    </b-table>
    <template v-if="loading">
      <div>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner :label="$t('common.laoding')" />
        </div>
      </div>
    </template>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
  <span class="text-muted"
                >{{ $t('common.showing') }} 1 {{ $t('common.to') }} 10
               </span
              >        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
          @click="index()"
        >
          <b-pagination
            v-model="page"
            :total-rows="totalRows"
            :per-page="take"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BSpinner,
  VBModal,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import ActionsButtons from '@/components/common/ActionsButtons.vue';

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BFormGroup,
    BSpinner,
    ActionsButtons
  },
  data() {
    return {
      tableColumns: [
        // { key: 'Id', label: '#', sortable: true },
        { key: 'Name',label:this.$t('common.name'), sortable: true },
        { key: 'Created_at',label:this.$t('common.created-at'), sortable: true },
        { key: 'Updated_at',label:this.$t('common.updated-at'), sortable: true },
        { key: 'Actions',label:this.$t('common.actions'), },
      ],
      loading: true,
      page: 1,
      take: 10,
      totalInvoices: 0,
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalRows: '',
      sortBy: 'id',
      isSortDirDesc: true,
      statusFilter: null,
      addForm: {
        name: '',
      },
      editForm: {
        name: '',
        _method: 'PUT',
      },
      editId: '',
      params: {
        form: {},
        path: '',
      },
      filterData: {
        name: '',
      },
      dataTable: [],
    };
  },
  mounted() {
    this.index();
  },
  methods: {
    async index() {
      await this.getList(
        `/role?take=${this.take}&page=${this.page}&filter[name]=${this.filterData.name}&sort=-created_at`
      );
      this.loading = false;
      this.totalRows = this.all_data.total;
      this.dataTable = this.all_data.data;
    },
    showModal() {
      this.$bvModal.show('modal-create');
    },
    showEditModel(item) {
      this.editForm.name = item.name;
      this.editId = item.id;
      this.$bvModal.show('modal-edit');
    },
    addRole() {
      (this.params.form = this.addForm),
        (this.params.path = '/role'),
        this.$store
          .dispatch('create', this.params)
          .then(() => {
            this.loading = true;
            this.index();
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Role Created',
                icon: 'success',
                variant: 'info',
                text: 'Role ' + this.addForm.name + ' Added Successfully',
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    editRole() {
      (this.params.form = this.editForm),
        (this.params.path = `role/${this.editId}`),
        this.$store
          .dispatch('update', this.params)
          .then(() => {
            this.loading = true;
            this.index();
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Role Updated',
                icon: 'success',
                variant: 'info',
                text: 'Role ' + this.editForm.name + ' Updated Successfully',
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
